import { BLOCK_ICON_MAP } from '../utils';
import BetaLabel from './BetaLabel';

type SettingsPermissionsItemProps = {
  iconName: string;
  title: string;
  description: string;
  hasValidCredentials?: boolean;
  onManageClick: () => void;
  onConnectClick: () => void;
  isLoading?: boolean;
  isBeta?: boolean;
}

function SettingsPermissionsItem(props: SettingsPermissionsItemProps) {
  const {
    iconName,
    title,
    description,
    hasValidCredentials,
    onManageClick,
    onConnectClick,
    isLoading,
    isBeta
  } = props;

  return (
    <div className="flex items-center">
      <img src={BLOCK_ICON_MAP[iconName]} className="w-8 h-8 flex-shrink-0" alt={`${title} Icon`} />
      <div className="flex flex-col ml-4 mr-8">
        <div className="font-semibold font-gilroy">
          {title}
        </div>
        {description}
      </div>
      {isBeta && <BetaLabel />}
      {hasValidCredentials === undefined || isLoading
        ? <button className="btn w-32 ml-auto" disabled>Loading...</button>
        : <>
          {
            hasValidCredentials
              ? <button className="btn btn-green w-32 ml-auto" onClick={onManageClick}>Manage</button>
              : <button className="btn btn-blue w-32 ml-auto" onClick={onConnectClick}>Connect</button>
          }
        </>
      }
    </div>
  );
}

export default SettingsPermissionsItem;
